import { defineStore } from 'pinia';
import { useStorage, StorageSerializers } from '@vueuse/core';
import { ref } from 'vue';
import type FlightSchool from '@/types/FlightSchool';
import { type AvailableParts, defaultPart } from '@/types/Certificate';

const partStorage = useStorage('userSelectedPart', null as AvailableParts | null, sessionStorage, { serializer: StorageSerializers.number });

export const usePartStore = defineStore('partSelection', () => {
    const selectedPart = ref<AvailableParts | null>(null);

    const setPart = (part: AvailableParts) => {
        selectedPart.value = part;
        partStorage.value = part;
    };

    const getPart = (): AvailableParts | null => selectedPart.value || partStorage.value;

    const clearPart = () => {
        selectedPart.value = null;
        partStorage.value = null;
    };

    const getPartOrUseDefault = (school?: FlightSchool | null): AvailableParts => (
        getPart() ?? school?.courses[0].certificate.part ?? defaultPart
    );

    return {
        selectedPart,
        setPart,
        getPart,
        clearPart,
        getPartOrUseDefault,
    };
});
